import { useMutation } from "@tanstack/react-query";
import { isUserExist } from "../../../api/requests/isUserExist";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useIsUserExist = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: isUserExist,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
